import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'button',
  name: '按钮',
  icon: '钮',
  group: '基础组件',
  description: '展示可配置的命令按钮',
  defaultProps: {
    text: '按钮',
    linkTarget: '',
    disabled: false,
    fullWidth: false
  }
}
